import HttpFactory from "~/repository/http.factory";
import type { PacksStampsCustomerReportResponse } from "~/types/report/response/packs.stamps.customer.report.response";
import type { SurveyCustomerReportResponse } from "~/types/report/response/survey.customer.report.response";

export default class PublicClient extends HttpFactory {
  private PUBLIC_RESOURCE = "/public";
  private headers: HeadersInit = {
    "Content-type": "application/json",
  };

  async customerWeeklyReport(
    scodiCampaignUuid: string
  ): Promise<
    PacksStampsCustomerReportResponse | SurveyCustomerReportResponse | null
  > {
    return await this.call<
      PacksStampsCustomerReportResponse | SurveyCustomerReportResponse | null
    >("GET", `${this.PUBLIC_RESOURCE}/report/customer/${scodiCampaignUuid}`);
  }
}
